import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { LoadingView } from "../../../../components";
import { Carriers } from "../../../../logos";
import InfoText from "../../components/InfoText";
import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";
import { FulfillmentDispatchType } from "../../types";

type Props = {
  type: FulfillmentDispatchType;
};

export default function DeliverySchedules({ type }: Props) {
  const { pickupSchedules } = useDeliveryFulfillments();
  const tailwind = useTailwind();

  if (!pickupSchedules) return <LoadingView />;

  const schedules = pickupSchedules.filter((s) => s.dispatch_type === type);

  if (!schedules.length) return null;

  const title = `Horario de ${
    type === "on_demand" ? "operación" : "recolección"
  }`;

  return (
    <View>
      <InfoText title={title} />
      <View style={tailwind("gap-1 mt-2")}>
        {schedules.map((s, index) => (
          <View key={index} style={tailwind("flex-row items-center gap-2")}>
            <Carriers.Logotype carrier={s.delivery_carrier_name} width={100} />
            <Text variant="bodyMedium" key={index}>
              {s.schedule}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}
